import { Stack, Typography } from "@mui/material";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";
import ArtifactAgentPickedPartChip from "./ArtifactAgentPickedPartChip";
import type { PickedPart } from "./pickedParts";

interface Props {
  content: string;
  pickedParts?: PickedPart[];
}

const ArtifactAgentUserMessage = ({ content, pickedParts = [] }: Props) => (
  <Stack spacing={0.5} sx={{ alignSelf: "flex-end", alignItems: "flex-end", maxWidth: "85%" }}>
    <Typography
      sx={(t) => ({
        px: 1.5,
        py: 1,
        borderRadius: "12px 12px 4px 12px",
        bgcolor: makeTintedBackgroundFromColor(t, t.palette.primary.main),
        whiteSpace: "pre-wrap",
        overflowWrap: "anywhere",
      })}
    >
      {content}
    </Typography>
    {pickedParts.length > 0 && (
      <Stack direction="row" spacing={0.5} useFlexGap sx={{ flexWrap: "wrap", justifyContent: "flex-end" }}>
        {pickedParts.map((part) => (
          <ArtifactAgentPickedPartChip key={part.line} part={part} />
        ))}
      </Stack>
    )}
  </Stack>
);

export default ArtifactAgentUserMessage;
